import React, { useState, memo } from "react";
import {
  HistoryDiv,
  Header,
  Tab,
  Thead,
  TBody,
  TRow,
  ProfitBox,
} from "./styledHistory";

// import { ReactComponent as UsdSVG } from "./usd.svg";
import { ReactComponent as CloseSVG2 } from "../../../svg/close2.svg";

import { ScalingContainer } from "../../../AppStyled";

import useSound from "use-sound";

import { requestBetReplay } from "../../../lib/socketMessages";
import currencies from "../../../lib/currencies/currencies";

import goForward from "../../../audio/goForward.mp3";
import closeSound from "../../../audio/goBack.mp3";
import tabClick from "../../../audio/tabClick.mp3";

export const History = memo(
  ({
    history,
    handleAbove,
    toFix,
    display,
    h,
    sound,
    volume,
    unBlur,
    scaleDown,
    user_id,
    handleNotification,
  }) => {
    const [closeSFX] = useSound(closeSound, { volume });
    const [tabSFX] = useSound(tabClick, { volume });
    const [goForwardSfx] = useSound(goForward, { volume });
    const clickHandler = (id, bet_user_id) => {
      if (bet_user_id === user_id) {
        if (sound) goForwardSfx();
        handleAbove("betReplay");
        requestBetReplay(id);
      } else {
        handleNotification("You can see only your bet reply");
      }
    };
    const [active, setactive] = useState("my");
    // const [currentData, setcurrentData] = useState([]);
    let array = [];
    if (active === "my") array = history.myHistory;
    if (active === "all") array = history.allHistory;
    if (active === "high") array = history.highRoller;

    return (
      <HistoryDiv
        style={display ? { display: "flex" } : { display: "none" }}
        unBlur={unBlur}
        scaleDown={scaleDown}
      >
        <ScalingContainer className="ScalingContainer" h={h}>
          <div>
            <Header>
              <Tab
                onClick={() => {
                  if (sound && active !== "my") tabSFX();
                  setactive("my");
                }}
                active={active === "my"}
              >
                <div className="inner"></div>
                <p>my</p>
              </Tab>
              <Tab
                onClick={() => {
                  if (sound && active !== "all") tabSFX();
                  setactive("all");
                }}
                active={active === "all"}
              >
                <div className="inner"></div>
                <p>all</p>
              </Tab>
              <Tab
                onClick={() => {
                  if (sound && active !== "high") tabSFX();
                  setactive("high");
                }}
                active={active === "high"}
              >
                <div className="inner"></div>
                <p>high</p>
              </Tab>
              <CloseSVG2
                style={{ width: "36px" }}
                onClick={() => {
                  if (sound) closeSFX();
                  handleAbove(false);
                }}
              />
            </Header>
            <div id="js-legend" className="chart-legend"></div>

            <Thead>
              <div>user</div>
              <div style={{ textAlign: "left", marginRight: "5px" }}>
                payout
              </div>
              <div style={{ textAlign: "right", marginLeft: "10px" }}>
                win amount
              </div>
            </Thead>
            <TBody>
              {array.map((it, index) => (
                <TRow
                  onClick={() => clickHandler(it.round_id, it.user_id)}
                  key={it.round_id}
                  pointer={user_id === it.user_id}
                >
                  <div
                    style={{
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textTransform: "none",
                      marginRight: "5px"
                    }}
                  >
                    {it.user_name}
                  </div>
                  <div
                    style={{
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      marginRight: "5px",
                      textTransform: "none",
                    }}
                  >
                    {it.winCoef.toFixed(2)}x
                  </div>
                  <ProfitBox>
                    <div
                      style={it.winAmount - it.betAmount > 0
                        ? {
                          textShadow: "0 0 8px  #ae51e4",
                          filter: "brightness(150%)",
                        }
                        : undefined
                      }
                    >
                      {it.winAmount}
                      <span style={{ marginLeft: '2px' }}>
                        {currencies[it.currency]}
                        {it.winAmount - it.betAmount > 0 ? " ↑" : " ↓"}
                      </span>
                    </div>
                  </ProfitBox>
                </TRow>
              ))}
            </TBody>
          </div>
        </ScalingContainer>
      </HistoryDiv >
    );
  },
);
